export const MATH_QUEST_4_QUESTIONS = [
  {
    id: 'mq4_1',
    text: '48 x 57',
    category: 'Math Quest 4',
    grade_level: '3A-3C',
    correct_answer: '2736',
    options: ['2736', '2637', '2836', '2730'],
  },
  {
    id: 'mq4_2',
    text: '5x + 6 = 41',
    category: 'Math Quest 4',
    grade_level: '3A-3C',
    correct_answer: '7',
    options: ['5', '6', '7', '8'],
  },
  {
    id: 'mq4_3',
    text: 'What is the perimeter if width is 5ft and length is twice the width?',
    category: 'Math Quest 4',
    grade_level: '3A-3C',
    correct_answer: '30',
    options: ['20', '25', '30', '35'],
  },
  {
    id: 'mq4_4',
    text: 'Solve: 3x - 4 = 11',
    category: 'Math Quest 4',
    grade_level: '3A-3C',
    correct_answer: '5',
    options: ['4', '5', '6', '7'],
  },
  {
    id: 'mq4_5',
    text: 'What is the volume of a cube with side length 4cm?',
    category: 'Math Quest 4',
    grade_level: '3A-3C',
    correct_answer: '64',
    options: ['16', '32', '48', '64'],
  },
  {
    id: 'mq4_opt_1',
    text: 'Solve for x: 2x + 6 = 18',
    category: 'Math Quest 4',
    grade_level: '3A-3C',
    options: ['x = 4', 'x = 5', 'x = 6', 'x = 7'],
    correct_answer: 'x = 6',
  },
];
